import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { MISC, API } from '@const'
import * as utils from '@utils'
import { Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, MenuItem, InputAdornment } from '@material-ui/core'
import { TextField } from '@prototype'
import { withStyles } from '@material-ui/styles'
import { green } from '@material-ui/core/colors'
import clsx from 'clsx'
import { TimePicker, MuiPickersUtilsProvider  } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns'
import moment from 'moment'


class DragonBoard extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'DragonBoard', options)
        }
        this.state = {
            dialogOpen: false,
            type: '',
            eventID: 0,
            account: '',
            accountList: MISC.EVENT_FAKEACCOUNT_LIST,
            accountCount: '',
            randomQuantity: ['', ''],
            frequency: 5,
            frequencyList: [5, 10, 30, 60, 120, 300, 480, 720, 1440],
            period: ['00:00', '23:59'],
            accumulation: '',
            amount: '',
            isSend: false,
            isLoading: true,
            valid: false,
            continue: false,
            addList: []
        }
    }

    componentDidMount() {
      const { eventID, type, detail } = this.props.options
      const init = {
        eventID,
        type,
        account: this.state.accountList[0]
      }
      
      if (type === 'edit') {
        init.account = detail.account
        init.randomQuantity = [detail.threshold_range_min, detail.threshold_range_max]
        init.frequency = detail.threshold_frequency
        init.accumulation = detail.threshold_target
        init.amount = detail.threshold_grand_total

        if (detail.frequency === 1440) {
            init.period = [detail.threshold_time_start, '00:00']
        } else {
            init.period = [detail.threshold_time_start, detail.threshold_time_end]
        }
      }
      this.setState({
        ...init,
        dialogOpen: true,
        isLoading: false
      })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
        this.props.closeDialog()
    }

    handleSubmit(callbackType) {
        this.setState({
            valid: true,
            isLoading: true,
            continue: callbackType === 'continue'
        })
        /** 資料驗證 */
        const valid = []
        if (this.state.type === 'add') {
            valid.push(this.handleAccountCountValid())
            valid.push(this.handleQuantityValid())
            valid.push(this.handleTimeValid())
        }
        valid.push(this.handleAccumulationValid())
        valid.push(this.handleAmountValid())
        /** 資料驗證錯誤 */
        if (valid.find(item => !item) === false) {
            this.setState({
                isLoading: false
            })
            return false 
        }

        const params = {}
        if (this.state.type === 'add') {
            params.add_count = Number(this.state.accountCount)
            params.account_prefix = this.state.account
            params.threshold_range_min = Number(this.state.randomQuantity[0])
            params.threshold_range_max = Number(this.state.randomQuantity[1])
            params.threshold_frequency = Number(this.state.frequency)
            params.threshold_time_start = this.state.period[0]
            params.threshold_time_end = this.state.period[1]
        } else {
            params.account = this.state.account
        }
        params.event_id = this.state.eventID
        params.threshold_target = Number(this.state.accumulation)
        params.threshold_grand_total = Number(this.state.amount) || 0

        const apiMethods = this.state.type === 'add' ? 'post' : 'put'
        utils.apiRequest(
            apiMethods,
            API.FAKEACCOUNT_DRAGON,
            params,
            (data) => {
                if (this.state.type === 'add') {
                    this.setState({
                        addList: data,
                        isSend: true,
                        isLoading: false
                    })
                } else {
                    this.handleConfirm()
                }
            },
            (err) => {
                if (err.code !== 300150) {
                    this.setState({
                        isLoading: false
                    })
                }
            }
        )
        
    }

    handleConfirm() {
        this.props.queryData()
        if (this.state.continue === false) {
            this.closeDialog()
        } else {
            this.setState({
                // account: this.state.accountList[0],
                // accountCount: '',
                // randomQuantity: ['', ''],
                // frequency: this.state.frequencyList[0],
                // period: ['00:00', '23:59'],
                // accumulation: '',
                // amount: '',
                isLoading: false,
                isSend: false,
                valid: false,
                continue: false
            })
        }
    }
    /** 驗證帳號創立數量 */
    handleAccountCountValid() {
        if (this.state.type === 'edit') {
            return true
        }
        if (this.state.accountCount === '' || Number(this.state.accountCount) < 1 || Number(this.state.accountCount) > 100 || isNaN(this.state.accountCount)) {
            return false
        }
        return true
    }
    /** 驗證隨機增加 */
    handleQuantityValid() {
        if (this.state.type === 'edit') {
            return true
        }
        if (this.state.randomQuantity[0] === '' || Number(this.state.randomQuantity[0]) < 0 || Number(this.state.randomQuantity[0]) > 10000 || isNaN(this.state.randomQuantity[0])) {
            return false
        } else if (this.state.randomQuantity[1] === '' || Number(this.state.randomQuantity[1]) < 0 || Number(this.state.randomQuantity[1]) > 10000 || isNaN(this.state.randomQuantity[1])) {
            return false
        } else if (Number(this.state.randomQuantity[1]) <= Number(this.state.randomQuantity[0])) {
            return false
        }
        return true
    }
    /** 驗證累積時段 */
    handleTimeValid() {
        if (this.state.type === 'edit' || this.state.frequency === 1440) {
            return true
        }
        const startTime = `${moment().format('YYYY-MM-DD')} ${this.state.period[0]}`
        let endTime = `${moment().format('YYYY-MM-DD')} ${this.state.period[1]}`
        /** 累積結束時間小於或等於累積起始時間,賦予跨天日期 */
        if (moment(endTime).isSameOrBefore(startTime)) {
            endTime = moment(endTime).add(1, 'd').format('YYYY-MM-DD HH:mm')
        }

        if (moment(endTime).isBefore(moment(startTime).add(this.state.frequency, 'minutes'))) {
            return false
        } else {
            return true
        }
    }
    /** 驗證壓碼量目標值 */
    handleAccumulationValid() {
        if (this.state.accumulation === '' || String(this.state.accumulation).length > 16 || Number(this.state.accumulation) === 0 || isNaN(this.state.accumulation)) {
            return false
        } else if (this.state.type === 'edit' && Number(this.state.accumulation) < Number(this.props.options.detail.threshold_target)) {
            return false
        } else {
            return true
        }
    }
    /** 壓碼量目標值錯誤訊息 */
    accumulationErrorMsg() {
        if (this.state.accumulation === '' || String(this.state.accumulation).length > 16 || Number(this.state.accumulation) === 0 || isNaN(this.state.accumulation)) {
            return this.t('accumulationRequired')
        } else if (this.state.type === 'edit' && Number(this.state.accumulation) < Number(this.props.options.detail.threshold_target)) {
            return this.t('accumulationError')
        }
    }
    /** 驗證預設壓碼量 */
    handleAmountValid() {
        if (this.state.type === 'add' && isNaN(this.state.amount)) {
            return false
        } else if (this.state.type === 'edit' && Number(this.state.amount) < Number(this.props.options.detail.threshold_grand_total)) {
            return false
        } else {
            return true
        }
    }
    /** 預設壓碼量錯誤訊息 */
    amountErrorMsg() {
        if (this.state.type === 'add' && isNaN(this.state.amount)) {
            return this.t('amountFormatValid')
        } else if (this.state.type === 'edit' && Number(this.state.amount) < Number(this.props.options.detail.threshold_grand_total)) {
            return this.t('amountError')
        }
    }
    /** 時間格式用 */
    createDateFromTextValue(value) {
        const splitParts = value.split(':');
        return new Date(1970, 1, 1, splitParts[0], splitParts[1]);
    }
    /** 小時轉分鐘 */
    transferFrequencyLabel(value){
        return value >= 60 ? this.t('everyHours', {value: value/60}) : this.t('everyMinutes', {value})
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} fullWidth maxWidth="xs" disableEscapeKeyDown={true}>
                <DialogTitle>{this.state.isSend ? this.t('view') : this.state.type === 'add'? this.t('add') : this.t('edit')}</DialogTitle>
                <DialogContent>
                    {!this.state.isSend && 
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Grid item xs={12}>
                                    {this.state.type === 'add' &&
                                        <TextField
                                            className={this.props.classes.formControl}
                                            select
                                            label={this.state.type === 'add'? this.t('fakeAccountPrefix') : this.t('fakeAccount')}
                                            value={this.state.account}
                                            onChange={(event) =>
                                                this.setState({
                                                    account: event.target.value,
                                                })
                                            }
                                        >
                                            {this.state.accountList.map(item => (
                                                <MenuItem key={item} value={item}>
                                                    {item}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    }
                                    {this.state.type === 'edit' && <TextField
                                        className={this.props.classes.textField}
                                        label={this.t('fakeAccount')}
                                        value={this.state.account}
                                        disabled={true}
                                    />}
                                </Grid>
                                {this.state.type === 'add' && <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.textField}
                                        label={this.t('createQuantity')}
                                        value={this.state.accountCount}
                                        required={true}
                                        onChange={(event) => {
                                            this.setState({
                                                accountCount: utils.clearNoNum(event.target.value, false, false)
                                            })
                                        }}
                                        error={this.state.valid && !this.handleAccountCountValid()}
                                        helperText={this.state.valid && !this.handleAccountCountValid() ? this.t('createQuantityValid') : ''}
                                    />
                                </Grid>}
                                <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.textField}
                                        label={this.t('randomIncrement')}
                                        value={this.state.randomQuantity[0]}
                                        required={true}
                                        onChange={(event) => {
                                            const randomQuantity = [...this.state.randomQuantity]
                                            randomQuantity[0] = utils.clearNoNum(event.target.value, false, false)
                                            this.setState({
                                                randomQuantity,
                                            })
                                        }}
                                        disabled={this.state.type === 'edit'}
                                        error={this.state.valid && !this.handleQuantityValid()}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end" className={this.props.classes.adornment}>{this.t('gameCurrency')}</InputAdornment>,
                                        }}
                                    />
                                    <span className={this.props.classes.fieldGroupInterval}>~</span> 
                                    <TextField
                                        className={clsx(this.props.classes.textField, this.props.classes.fieldGroupAfter)}
                                        label=''
                                        value={this.state.randomQuantity[1]}
                                        required={true}
                                        onChange={(event) => {
                                            const randomQuantity = [...this.state.randomQuantity]
                                            randomQuantity[1] = utils.clearNoNum(event.target.value, false, false)
                                            this.setState({
                                                randomQuantity,
                                            })
                                        }}
                                        disabled={this.state.type === 'edit'}
                                        error={this.state.valid && !this.handleQuantityValid()}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end" className={this.props.classes.adornment}>{this.t('gameCurrency')}</InputAdornment>,
                                        }}
                                    />
                                    {(this.state.valid && !this.handleQuantityValid()) && <div className={clsx(this.props.classes.remark, this.props.classes.validContent)}>{this.t('randomIncrementValid')}</div>}
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.formControl}
                                        select
                                        label={this.t('increaseFrequency')}
                                        value={this.state.frequency}
                                        onChange={(event) =>
                                            this.setState({
                                                frequency: event.target.value,
                                            })
                                        }
                                        disabled={this.state.type === 'edit'}
                                    >
                                        {this.state.frequencyList.map(item => (
                                            <MenuItem key={item} value={item}>
                                                {this.transferFrequencyLabel(item)}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <TimePicker
                                            className={this.props.classes.timePicker}
                                            clearable={false}
                                            ampm={false}
                                            label={this.state.frequency === 1440 ? this.t('cumulativeStartTime') : this.t('accumulationPeriod')}
                                            value={this.createDateFromTextValue(this.state.period[0])}
                                            onChange={(value)=>{
                                                const period = [...this.state.period]
                                                period[0] = moment(value).format('HH:mm')
                                                this.setState({
                                                    period,
                                                })
                                            }}
                                            disabled={this.state.type === 'edit'}
                                            error={this.state.valid && !this.handleTimeValid()}
                                        />
                                        <span className={clsx(this.props.classes.fieldGroupInterval, {
                                            [this.props.classes.hide]: this.state.frequency === 1440
                                        })}>~</span>
                                        <TimePicker
                                            className={clsx(this.props.classes.timePicker, this.props.classes.fieldGroupAfter,{
                                                [this.props.classes.hide]: this.state.frequency === 1440
                                            })}
                                            clearable={false}
                                            ampm={false}
                                            label=""
                                            value={this.createDateFromTextValue(this.state.period[1])}
                                            onChange={(value)=>{
                                                const period = [...this.state.period]
                                                period[1] = moment(value).format('HH:mm')
                                                this.setState({
                                                    period,
                                                })
                                            }}
                                            disabled={this.state.type === 'edit'}
                                            error={this.state.valid && !this.handleTimeValid()}
                                        />
                                    </MuiPickersUtilsProvider>
                                    {(this.state.valid && !this.handleTimeValid()) &&<div className={clsx(this.props.classes.remark, this.props.classes.validContent)}>{this.t('cumulativeStartTimeValid')}</div>}
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.textField}
                                        label={this.t('betAmountTarget')}
                                        value={this.state.accumulation}
                                        required={true}
                                        onChange={(event) => {
                                            this.setState({
                                                accumulation: utils.clearNoNum(event.target.value, false, false)
                                            })
                                        }}
                                        error={this.state.valid && !this.handleAccumulationValid()}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end" className={this.props.classes.adornment}>{this.t('gameCurrency')}</InputAdornment>,
                                        }}
                                    />
                                    <span className={this.props.classes.remark}>({this.t('stopWhenAchieved')})</span>
                                    {(this.state.valid && !this.handleAccumulationValid()) && <div className={clsx(this.props.classes.remark, this.props.classes.validContent)}>{this.accumulationErrorMsg()}</div>}
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.textField}
                                        label={this.state.type === 'add' ? this.t('defaultBetAmount') : this.t('currentBetAmount')}
                                        value={this.state.amount}
                                        onChange={(event) => {
                                            this.setState({
                                                amount: utils.clearNoNum(event.target.value, false, false)
                                            })
                                        }}
                                        error={this.state.valid && !this.handleAmountValid()}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end" className={this.props.classes.adornment}>{this.t('gameCurrency')}</InputAdornment>,
                                        }}
                                    />
                                    {this.state.type === 'edit' && <span className={this.props.classes.remark}>({this.t('setBetAmountRemark')})</span>}
                                    {(this.state.valid && !this.handleAmountValid()) && <div className={clsx(this.props.classes.remark, this.props.classes.validContent)}>{this.amountErrorMsg()}</div>}
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    {this.state.isSend && 
                        <Grid container spacing={2}>
                            <Grid item xs={12} className={this.props.classes.addListHeader}>
                                {this.t('accountBeenAdd', {value: this.state.addList.length})}
                            </Grid>
                            <Grid item xs={12} className={this.props.classes.addListContent}>
                                {this.state.addList.map(account => (
                                    <span key={account}>
                                        {account}
                                    </span>
                                ))}
                            </Grid>
                        </Grid>
                    }
                </DialogContent>
                <Divider />
                <DialogActions>
                    {(this.state.type === 'add' && !this.state.isSend) && 
                        <>
                            <Button variant="contained" onClick={() => this.closeDialog()} color="secondary" disabled={this.state.isLoading}>
                                {this.t('cancel')}
                            </Button>
                            <Button variant="contained" onClick={() => this.handleSubmit()} color="primary" disabled={this.state.isLoading}>
                                {this.t('closeAfterAdd')}
                            </Button>
                            <GreenButton variant="contained" onClick={() => this.handleSubmit('continue')} color="primary" disabled={this.state.isLoading}>
                                {this.t('continueAfterAdd')}
                            </GreenButton>
                        </>
                    }
                    {this.state.isSend && 
                        <Button variant="contained" onClick={() => this.handleConfirm()} color="primary">
                            {this.t('confirm')}
                        </Button>
                    }
                    {this.state.type === 'edit' &&
                        <>
                            <Button variant="contained" onClick={() => this.closeDialog()} color="secondary" disabled={this.state.isLoading}>
                                {this.t('cancel')}
                            </Button>
                            <Button variant="contained" onClick={() => this.handleSubmit()} color="primary" disabled={this.state.isLoading}>
                                {this.t('save')}
                            </Button>
                        </>
                    }
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: 150,
        },
        textField: {
            margin: theme.spacing(1),
            width: 150,
        },
        timePicker: {
            margin: theme.spacing(1),
            width: 150,
            '& input': {
                paddingTop: 3
            }
        },
        fieldGroupAfter: {
            marginTop: 24
        },
        fieldGroupInterval: {
            display: 'inline-flex',
            marginTop: 26
        },
        hide: {
            display: 'none'
        },
        remark: {
            display: 'inline-flex',
            fontSize: '0.75rem',
            color: '#ff0000',
            marginTop: 28
        },
        validContent: {
            width: '100%',
            marginTop: '-5px',
            position: 'relative',
            display: 'block',
            paddingLeft: 8
        },
        adornment: {
            display: 'inline-flex',
            height: 'auto',
            whiteSpace: 'nowrap',
            '& p': {
                fontSize: 12
            }
        },
        addListHeader: {
            textAlign: 'center',
            fontSize: 15,
            color: '#69131c'
        },
        addListContent: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
            '& span': {
                width: '100%',
                textAlign: 'center'
            }
        }
    }
}

const GreenButton = withStyles(() => ({
    root: {
      color: '#ffffff',
      backgroundColor: green[500],
      '&:hover': {
        backgroundColor: green[700],
      },
    },
}))(Button);

DragonBoard.propTypes = {
    classes: PropTypes.object.isRequired,
    closeDialog: PropTypes.func,
    options: PropTypes.object,
    queryData: PropTypes.func,
}

export default hoc(styles)(DragonBoard)
